// src/components/ServicesSectionWide.jsx
import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css"; // ensure installed

const defaultItems = [
  {
    icon: "/images/page-img/Parking.png",
    title: "Parking",
    text:
      "Adequate parking facilities have been thoughtfully provided to ensure the utmost convenience for our residents, addressing their parking needs seamlessly.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Free-Wifi.png",
    title: "Free Wifi",
    text:
      "In this fast-paced digital age, connectivity is key, and Shree Swami Samarth PG is committed to providing residents with a seamless online experience through free WiFi services.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Refrigerator.png",
    title: "Refrigerator",
    text:
      "Each room is thoughtfully equipped with a refrigerator, adding a touch of convenience to residents' stays by providing a handy space for storing and preserving their essentials.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Almirah.png",
    title: "Almirah",
    text:
      "In every room, residents benefit from the availability of spacious almirahs, ensuring organized and efficient storage solutions to enhance their living experience.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Bed-Sheet.png",
    title: "Bed Sheet",
    text:
      "Every resident is treated to the luxury of fresh and clean bed sheets, ensuring a comfortable and hygienic sleeping environment that reflects our commitment to their well-being.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Pillows.png",
    title: "Pillows",
    text:
      "To guarantee a restful night's sleep, each resident is provided with comfortable pillows, emphasizing our commitment to ensuring their overall well-being,relaxation during their stay.",
    href: "/services-single.html",
  },



  {
    icon: "/images/page-img/CCTV-Camera.png",
    title: "CCTV Camera",
    text:
      "Prioritizing the safety of our residents, key areas are equipped with CCTV cameras, underscoring our commitment to maintaining a secure and protected living environment.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Housekeeping.png",
    title: "Housekeeping",
    text:
      "Ensuring a consistently clean and hygienic living environment, residents benefit from regular housekeeping services that exemplify our commitment to their comfort.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Security.png",
    title: "Security",
    text:
      "The safety of all residents is paramount, and it is guaranteed by our round-the-clock security measures, reflecting our unwavering commitment to providing a secure environment.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Drink-Water.png",
    title: "Drink Water",
    text:
      "Residents can enjoy peace of mind with readily available filtered and safe drinking water, a testament to our commitment to ensuring their health and well-being during their stay.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Reception.png",
    title: "Reception",
    text:
      "The welcoming reception area serves as a hub for assistance and information, embodying our commitment to providing residents with a helpful and hospitable experience.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Washroom.png",
    title: "Washroom",
    text:
      "Residents benefit from conveniently accessible and well-maintained washrooms, reflecting our commitment to ensuring their comfort and satisfaction with the overall living.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Washing-Machine.png",
    title: "Washing Machine",
    text:
      "Residents enjoy convenient amenities such as round-the-clock security, filtered drinking water, and on-site laundry facilities, reflecting our commitment to their comfort.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Hot-Water.png",
    title: "24x7 Hot Water",
    text:
      "Ensuring residents' comfort, continuous access to hot water is provided, exemplifying our commitment to enhancing their overall living experience.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Free-Wifi.png",
    title: "Free Electricity",
    text:
      "Electricity usage is included in the accommodation package, ensuring a hassle-free and transparent living experience for residents.",
    href: "/services-single.html",
  },
  {
    icon: "/images/page-img/Breakfast-Dinner.png",
    title: "Breakfast & Dinner",
    text:
      "Complimentary nutritious and delicious breakfast and dinner are provided for all residents, reflecting our commitment to enhancing their dining experience and overall well-being.",
    href: "/services-single.html",
  },
];

export default function ServicesSectionWide({ items = defaultItems }) {
  return (
  <>


 <section
      className="page-title"
      style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
    >
      <div className="auto-container">
        <h1>Amenities</h1>
       
      </div>
    </section>

    <section className="services-section-two style-two">
      <div className="auto-container">
        {/* Services Title */}
        <div className="services-title">
          <h3>
          Modern Amenities for a Holistic Living Experience
Enjoy a Range of Facilities at Shree Swami Samarth PG
          </h3>
          <div className="separator"></div>
        </div>

        <div className="row clearfix">
          {items.map((it, i) => (
            <div className="services-block-two style-two col-md-4 col-sm-6 col-xs-12" key={i}>
              <div className="inner-box">
                <div className="icon-box">
                  <img src={it.icon} alt="" />
                </div>
                <h3>
                  <a href={it.href}>{it.title}</a>
                </h3>
                <div className="text">{it.text}</div>
             
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
  );
}
